// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__TrpAg","tag__text":"Tag_tag__text__6hA9l","tag__button":"Tag_tag__button__1gQ6H"};